import { AirWeightBracketPrice } from "./air-weight-bracket-price.model";

export class AirWeightBracketPriceMapper {
  static map(data: any): AirWeightBracketPrice {
    return new AirWeightBracketPrice(data.name, data.value);
  }
}
